import { Dispatch } from 'react';
import { get, post, put } from 'communication/httpClient';
import {
  STORE_SET,
  STORES_SET,
  STORE_SET_SAVED,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
} from './actionTypes';
import { IStore, IStoresAction, IStoresActions } from './types';

export const getActions = (dispatch: Dispatch<IStoresAction>): IStoresActions => ({
  loadStore: async (id: string) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get(`/api/stores/${id}`);

    if (data) {
      dispatch({
        type: STORE_SET,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  loadStores: async (params) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get(`/api/stores?${new URLSearchParams(params)}`);

    if (data) {
      dispatch({
        type: STORES_SET,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  saveStore: async (store: IStore) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const handler = store.enterpriseUnitId ? put : post;
    const url = store.enterpriseUnitId ? `/api/stores/${store.enterpriseUnitId}` : '/api/stores';
    const { error } = await handler(url, store);

    if (!error) {
      dispatch({
        type: STORE_SET_SAVED,
      });
      dispatch({
        type: STORE_SET,
        payload: store,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
});
